import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { getNPPEsDetailsData } from "../../../actions/Master";
import { resetStates } from "../../../actions/Common";
import NppesSearchComponent from "../components/NppesSearchComponent";



const mapStateToProps = ({
  nppesDetailsDataState,
}: ApplicationState) => ({
  PhysicianDetailsData: nppesDetailsDataState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    any
  >
) => {
  return {
    getNPPESDetails: (payload: any) => {
      dispatch(getNPPEsDetailsData(payload));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NppesSearchComponent);
